export default {
  RESPONSE_SUCCESS: {
    code: '000000',
    message: '操作成功',
  },
  RESPONSE_FAILURE: {
    code: '999999',
    message: '操作失败',
  },
  REQUEST_PARMAS_ERR: {
    code: '999998',
    message: '参数错误',
  },
};



// WEBPACK FOOTER //
// ./src/lib/requestStatusCode.js